import React from "react";

function UsersList() {
  return <div>UsersList</div>;
}

export default UsersList;
